import React from "react"

const UsersSignIn = React.lazy(() => import("components/chalky-layout/sign-in"))

// api-maker's SuperAdmin ConfigReader looks up model configs by dasherized
// model name via `config.modelConfigs`. Discover everything under
// ./model-configs via webpack's require.context so new configs are picked up
// without touching this file.
const modelConfigContext = require.context("./model-configs", false, /\.(jsx|js)$/)
const modelConfigPathByName = modelConfigContext.keys().reduce((paths, configPath) => {
  paths[configPath.replace(/^\.\//, "").replace(/\.(jsx|js)$/, "")] = configPath

  return paths
}, {})

const modelConfigs = (modelNameDasherized) => {
  const configPath = modelConfigPathByName[modelNameDasherized]

  if (!configPath) return undefined

  return modelConfigContext(configPath).default
}

export default {
  modelConfigs,
  signInContent: () => <UsersSignIn />
}
